import { Box, Typography } from '@mui/material';

interface DoseTargetTableDataRow {
    targetName: string;
    doseQuantity: number;
}

interface DoseTargetTableProps {
    data: DoseTargetTableDataRow[];
}

const DoseTargets = ({ data }: DoseTargetTableProps) => {
    return (
        <Box>
            {data.map((row) => (
                <Box
                    key={row.targetName}
                    display="grid"
                    gridTemplateColumns="1fr auto"
                    justifyContent="space-between"
                    alignItems={'center'}
                    gap={0.5}
                >
                    <Typography
                        fontSize={12}
                        color="text.secondary"
                        sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {row.targetName}
                    </Typography>
                    <Typography fontSize={11} color="text.secondary">
                        {row.doseQuantity.toFixed(1)} Gy
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default DoseTargets;
